//@flow
import * as React from 'react'

import { Flex } from 'components/common'
import { useNotAllowedStyles } from './styles'
import { useI18n } from '~/core/i18n'

type NotAllowedProps = {
  info?: string,
  TextComponent?: React.Node,
  Tools?: React.Node
}

const NotAllowed = ({ TextComponent, Tools, info, ...props }: NotAllowedProps) => {
  const [msg] = useI18n()
  const classes = useNotAllowedStyles()

  return (
    <Flex className={classes.notAllowed} column id="not-allowed" {...props}>
      <h1>{`༼ つ ◕_◕ ༽つ`}</h1>
      <h2>{TextComponent || msg('common.errors.notAllowedAccess')}</h2>
      {info && <p className={classes.info}>{info}</p>}
      {Tools && <div className={classes.tools}>{Tools}</div>}
    </Flex>
  )
}

export default NotAllowed
